export default __webpack_public_path__ + "static/media/Large_Gradient_Background.e29b2cee.png";